import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext, StateToken } from '@ngxs/store';

import { OnboardingStoreActions } from './store.action';
import { StateModel } from './store.model';

export const onboardingStoreDefaults: StateModel = {
  hasVendorPartner: null
};

export const ONBOARDING_STORE_STATE_TOKEN = new StateToken<StateModel>('app');

@State<StateModel>({
  name: ONBOARDING_STORE_STATE_TOKEN,
  defaults: onboardingStoreDefaults
})
@Injectable()
export class OnboardingStoreState implements NgxsOnInit {

  @Selector()
  static hasVendorPartner(state: StateModel): boolean {
    return state.hasVendorPartner!;
  }

  constructor() { }

  ngxsOnInit(): void { }

  @Action(OnboardingStoreActions.HasVendorPartner)
  hasVendorPartner( ctx: StateContext<StateModel>, action: OnboardingStoreActions.HasVendorPartner): void {
    ctx.patchState({ hasVendorPartner: action.state });
  }

}
